// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"BackgroundAnimation_iconWrapper__zOdD9","iconDesktop":"BackgroundAnimation_iconDesktop__sIk27","progressBar":"BackgroundAnimation_progressBar__9Gidv"};